/* Hearthwell theme scripts. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  var menu = document.getElementById('MobileMenu');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
  if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  /* ---------- Cart count ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  /* ---------- Money formatting ---------- */
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency, minimumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Product page ---------- */
  var section = document.querySelector('[data-product-section]');
  if (section) {
    var data = JSON.parse(document.querySelector('[data-product-json]').textContent);
    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var qtyInput = section.querySelector('[data-quantity]');
    var priceEl = section.querySelector('[data-price]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var addLabel = section.querySelector('[data-add-label]');
    var errorEl = section.querySelector('[data-form-error]');
    var colourLabel = section.querySelector('[data-colour-label]');
    var sizeLabel = section.querySelector('[data-size-label]');
    var gallery = section.querySelector('[data-gallery]');
    var sticky = document.querySelector('[data-sticky-atc]');

    var state = { colour: null, size: null, tier: 1 };
    var pressedColour = section.querySelector('[data-colour][aria-pressed="true"]');
    var pressedSize = section.querySelector('[data-size][aria-pressed="true"]');
    state.colour = pressedColour ? pressedColour.getAttribute('data-colour') : data.variants[0].option1;
    state.size = pressedSize ? pressedSize.getAttribute('data-size') : data.variants[0].option2;

    function findVariant() {
      return data.variants.find(function (v) { return v.option1 === state.colour && v.option2 === state.size; });
    }

    function slides() { return gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-media-id]')) : []; }
    function showMedia(id) {
      if (!gallery || !id) return;
      var list = slides(), idx = 0;
      list.forEach(function (el, i) {
        var on = String(el.getAttribute('data-media-id')) === String(id);
        el.hidden = !on;
        if (on) idx = i;
      });
      gallery.querySelectorAll('[data-thumb]').forEach(function (el) {
        var on = String(el.getAttribute('data-thumb')) === String(id);
        if (on) { el.setAttribute('aria-current', 'true'); if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest', inline: 'center' }); }
        else el.removeAttribute('aria-current');
      });
      var counter = gallery.querySelector('[data-gallery-index]');
      if (counter) counter.textContent = idx + 1;
    }
    function step(dir) {
      var list = slides();
      if (!list.length) return;
      var cur = list.findIndex(function (el) { return !el.hidden; });
      var next = (cur + dir + list.length) % list.length;
      showMedia(list[next].getAttribute('data-media-id'));
    }
    if (gallery) {
      var prev = gallery.querySelector('[data-gallery-prev]'), next = gallery.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      var startX = null, main = gallery.querySelector('.gallery__main');
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
        startX = null;
      });
    }

    function tierTotals(price) {
      var off2 = data.bundle2 / 100, off3 = data.bundle3 / 100;
      return {
        1: { was: price, now: price },
        2: { was: price * 2, now: Math.round(price * 2 * (1 - off2)) },
        3: { was: price * 3, now: Math.round(price * 3 * (1 - off3)) }
      };
    }

    var firstRender = true;
    function render() {
      var v = findVariant();
      var unavailable = !v || !v.available;
      if (colourLabel) colourLabel.textContent = state.colour;
      if (sizeLabel) sizeLabel.textContent = state.size;

      section.querySelectorAll('[data-colour]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-colour') === state.colour));
      });
      section.querySelectorAll('[data-size]').forEach(function (b) {
        var size = b.getAttribute('data-size');
        b.setAttribute('aria-pressed', String(size === state.size));
        var exists = data.variants.some(function (x) { return x.option1 === state.colour && x.option2 === size && x.available; });
        b.disabled = !exists;
      });

      if (!v) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      qtyInput.value = state.tier;
      priceEl.textContent = formatMoney(v.price, data.currency);

      var totals = tierTotals(v.price);
      [1, 2, 3].forEach(function (n) {
        var priceNode = section.querySelector('[data-tier-price="' + n + '"]');
        var wasNode = section.querySelector('[data-tier-was="' + n + '"]');
        if (priceNode) priceNode.textContent = formatMoney(totals[n].now, data.currency);
        if (wasNode) wasNode.textContent = n > 1 ? formatMoney(totals[n].was, data.currency) : '';
      });

      addBtn.disabled = unavailable;
      addLabel.textContent = unavailable ? 'Sold out' : 'Add to cart';

      var stickyPrice = document.querySelector('[data-sticky-price]');
      var stickyVariant = document.querySelector('[data-sticky-variant]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(totals[state.tier].now, data.currency);
      if (stickyVariant) stickyVariant.textContent = state.colour + ' · ' + state.size;

      if (!firstRender) {
        if (v.media) showMedia(v.media);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
    }

    section.addEventListener('click', function (e) {
      var colourBtn = e.target.closest('[data-colour]');
      var sizeBtn = e.target.closest('[data-size]');
      var thumb = e.target.closest('[data-thumb]');
      if (colourBtn) {
        state.colour = colourBtn.getAttribute('data-colour');
        // keep size valid for new colour
        if (!data.variants.some(function (x) { return x.option1 === state.colour && x.option2 === state.size; })) {
          var first = data.variants.find(function (x) { return x.option1 === state.colour; });
          if (first) state.size = first.option2;
        }
        render();
      } else if (sizeBtn && !sizeBtn.disabled) {
        state.size = sizeBtn.getAttribute('data-size');
        render();
      } else if (thumb) {
        showMedia(thumb.getAttribute('data-thumb'));
      }
    });

    section.querySelectorAll('input[name="tier"]').forEach(function (r) {
      r.addEventListener('change', function () { state.tier = parseInt(r.value, 10); render(); });
    });

    function addToCart() {
      errorEl.hidden = true;
      addBtn.disabled = true;
      var fd = new FormData();
      fd.append('id', idInput.value);
      fd.append('quantity', qtyInput.value);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, body: j }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error(r.body.description || r.body.message || 'Could not add to cart.');
          return fetch('/cart.js').then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          window.location.href = '/cart';
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          addBtn.disabled = false;
        });
    }


    // "Choose <size>" buttons elsewhere on the page: select that size, then jump up to the buy box
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-select-size]');
      if (!btn) return;
      e.preventDefault();
      var key = btn.getAttribute('data-select-size').toLowerCase();
      var match = data.variants.find(function (x) { return x.option2.toLowerCase().indexOf(key) === 0 && x.option1 === state.colour && x.available; }) ||
                  data.variants.find(function (x) { return x.option2.toLowerCase().indexOf(key) === 0 && x.available; });
      if (match) { state.colour = match.option1; state.size = match.option2; render(); }
      var target = document.getElementById('buy');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      section.querySelectorAll('.size-btn[aria-pressed="true"]').forEach(function (b) {
        b.classList.remove('is-flash'); void b.offsetWidth; b.classList.add('is-flash');
      });
    });

    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });

    if (sticky) {
      var stickySubmit = sticky.querySelector('[data-sticky-submit]');
      stickySubmit.addEventListener('click', addToCart);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var show = !en.isIntersecting && en.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', String(!show));
          });
        });
        io.observe(addBtn);
      }
    }

    render();
    firstRender = false;
  }

  /* ---------- Cart page quantity steppers ---------- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      var input = cartForm.querySelector('[data-line-qty="' + btn.getAttribute('data-line') + '"]');
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10));
      input.value = next;
      var hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
      cartForm.appendChild(hidden);
      cartForm.submit();
    });
    cartForm.querySelectorAll('[data-line-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
        cartForm.appendChild(hidden);
        cartForm.submit();
      });
    });
  }
})();
